import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { differenceInDays, differenceInHours, formatDistanceStrict, parseISO } from 'date-fns';

import { isNumber, normalizeTimestamp } from '@app/shared/utils';

@Pipe({
  name: 'daysPassed',
})
export class DaysPassedPipe implements PipeTransform {
  constructor(private datePipe: DatePipe) {}

  transform(value: string, isWord: boolean = false, inHours: boolean = false): any {
    const parsedDate = isNumber(value) ? new Date(normalizeTimestamp(value)) : parseISO(value);
    const daysPassed = differenceInDays(new Date(), parsedDate);

    if (daysPassed === 1) {
      return 'Yesterday';
    }
    if (daysPassed === 0) {
      return inHours ? this.transformToMinutes(parsedDate) : 'Today';
    }
    return isWord
      ? this.datePipe.transform(parsedDate, 'shortDate')
      : formatDistanceStrict(parsedDate, new Date(), { unit: 'day' }) + ' old';
  }

  transformToMinutes(value: Date) {
    return differenceInHours(new Date(), value) === 0
      ? formatDistanceStrict(value, new Date(), { unit: 'minute' }) + ' ago'
      : formatDistanceStrict(value, new Date(), { unit: 'hour' }) + ' ago';
  }
}
